import _ from 'lodash';
import createjs from 'createjs-collection';

import * as fJS from './../cjsRoot/fJS';
import { cjsItem } from './../cjsRoot/cjsBase';
import { cjsHook } from './../cjsObjects/cjsHook';
import { cjsEffects } from './../cjsObjects/cjsEffects';
import STORE from '@/store';

export class cjsSelect extends cjsItem {
  _check;
  _good;

  constructor(obj) {
    super(obj);
    if (this._stage.otherProperty == null || typeof this._stage.otherProperty == 'undeifned')
      this._stage._otherProperty = {};
  }

  create() {
    if (Array.isArray(this.tCheck)) this.arrangeItems('tCheck');

    super.create();

    if (Array.isArray(this.tCheck) || (typeof this.check === 'object' && this.check !== null)) {
      if (typeof this.check === 'object' && this.check !== null) {
        delete this.check;
        delete this._good;
        this._createCheck(true);
      }
      this.check = this.tCheck[0];
      this._good = this.tCheck[1];
      delete this.tCheck;
      this.check.create();
      this.check.toVisible = this.check._container.visible =
        typeof this.otherProperty.pair.check.visible === 'boolean'
          ? this.otherProperty.pair.check.visible
          : this._stage.defConfig.pair.checkVisible;

      this._container.addChild(this.check._container);
      if (typeof this._good !== 'undefined' && this._good != null) {
        this._good.create();
        this._good.toVisible = this._good._container.visible =
          typeof this.otherProperty.pair.good.visible === 'boolean'
            ? this.otherProperty.pair.good.visible
            : this._stage.defConfig.pair.checkVisible;

        this._container.addChild(this._good._container);
      }
    }
    this._offPressOnClick(this._stage);
  }

  _offPressOnClick(stage) {
    if (this.container.listener === undefined) {
      this.container.listener = {};
    } else {
      if (this._container.listener.md !== undefined) {
        this._container.off('mousedown', this._container.listener.md);
        delete this._container.listener.md;
      }
      if (this._container.listener.pu !== undefined) {
        this._container.off('pressup', this._container.listener.pu);
        delete this._container.listener.pu;
      }
    }
    this.container.children.forEach(function (child) {
      if (child.listener !== undefined && child.listener.md !== undefined) {
        child.off('mousedown', child.listener.md);
        delete child.listener.md;
      }
      if (child.listener !== undefined && child.listener.pu !== undefined) {
        child.off('pressup', child.listener.pu);
        delete child.listener.pu;
      }
    });

    if (this.block === false) {
      this.container.listener.c = this.container.on('click', this.stageMouseClick, null, false, {
        engine: this,
        cjsStage: stage,
      });
    }
  }

  _createCheck(dontCreate) {
    this.tCheck = [];
    this.tCheck[0] = this._createItemCheck(this.otherProperty.pair, 'check');

    if (typeof this.otherProperty.pair.good !== 'undefined' && this.otherProperty.pair.good != null) {
      this.tCheck[1] = this._createItemCheck(this.otherProperty.pair, 'good');
    }

    if (dontCreate !== true) {
      this.tCheck[0].create();
      if (typeof this.otherProperty.pair.good !== 'undefined' && this.otherProperty.pair.good != null) {
        this.tCheck[1].create();
      }
    }
  }

  _createItemCheck(obj, prop) {
    let check = new cjsCheck([
      _.merge(_.cloneDeep(obj[prop]), {
        id: prop,
        idGroup: this.idGroup,
        idItem: this.id,
      }),
      this._stage,
      obj,
    ]);
    check.setLayout('background', false, obj, obj[prop], false);
    check.setLayout('positions', false, obj, obj[prop], false);
    check.setLayout('shadow', false, obj, obj[prop], false);

    check.offset = null;

    // PADDINGI
    check.setMargin('padding', false, false, obj[prop], false);

    if (!check.isAbsolute()) {
      // MARGINESY
      check.setMargin('margin', false, false, obj[prop], false);
      check.offset = {};
    }
    return check;
  }

  setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules) {
    super.setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules);

    if (
      typeof this.otherProperty.pair !== 'object' ||
      typeof this.otherProperty.pair.check !== 'object' ||
      this.otherProperty.pair.check === null
    )
      return false;

    this._stage._otherProperty.autoChangeSelect =
      this.otherProperty.pair.check.autoChangeSelect === true ? true : this._stage.otherProperty.autoChangeSelect;

    this._createCheck();
  }

  stageMouseClick(e, data) {
    let stage = data.cjsStage,
      engine = data.engine;
    if (engine.block === true) {
      e.stopPropagation();
      return false;
    }
    stage.sounds.play(engine.idGroup + '.' + engine.id + '.mouseup');
    if (stage.otherProperty.autoChangeSelect === true) {
      for (let i in stage.groups[engine.idGroup].items) {
        let item = stage.groups[engine.idGroup].items[i];
        if (i == engine.id || item.block == true) {
          continue;
        }
        item.check.visible = false;
        item.check._container.visible = false;
        item.check._container.alpha = 1;
        if (item._container.cacheID !== 0) item._container.updateCache();
      }
    }

    engine.check._container.visible = !engine.check.visible;
    engine.check._container.alpha = 1;

    if (engine._container.cacheID !== 0) engine._container.updateCache();

    if (stage.autoCheckAllCorrect === true && cjsSelect.checkGameAction.call(this, stage, false) === true) {
      STORE.dispatch('checkGame');
    }

    e.stopPropagation();
  }

  get check() {
    return this._check;
  }
  set check(v) {
    this._check = v;
  }
  get good() {
    return this._good;
  }
  set good(v) {
    this._good = v;
  }
}

cjsSelect.checkGameAction = function (stage, droped) {
  console.log('cjsSelect CHECK');
  let isCorrect = true,
    isCheckGood = false;

  let checks = {};
  for (let gr in stage.groups) {
    if (typeof checks[gr] !== 'object' || checks[gr] === null) checks[gr] = {};
    for (let i in stage.groups[gr].items) {
      isCheckGood =
        typeof stage.groups[gr].items[i].good != undefined && stage.groups[gr].items[i].good != null
          ? true
          : isCheckGood;
      if (typeof checks[gr][i] !== 'boolean') checks[gr][i] = stage.groups[gr].items[i].block === true;

      if (stage.groups[gr].items[i].block === true) continue;
      stage.groups[gr].items[i].isCorrect = false;
      for (let c = 0; c < stage.groups[gr].items[i].correct.length; c++) {
        if (
          typeof checks[stage.groups[gr].items[i].correct[c].idGroup] !== 'object' ||
          checks[stage.groups[gr].items[i].correct[c].idGroup] === null
        )
          checks[stage.groups[gr].items[i].correct[c].idGroup] = {};
        checks[stage.groups[gr].items[i].correct[c].idGroup][stage.groups[gr].items[i].correct[c].idItem] = true;
      }
    }
  }

  let remove = [];
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      if (stage.groups[gr].items[i].block === true) continue;

      if (stage.groups[gr].items[i].check.visible !== checks[gr][i]) {
        isCorrect = false;
        if (droped === false) continue;
        if (remove.indexOf(gr) === -1) {
          remove.push(gr);
        }
        if (stage.removeInCorrects !== true || stage.groups[gr].items[i].check.visible === false) {
          continue;
        }
        stage.groups[gr].items[i].check.toVisible = false;
        stage.groups[gr].items[i].check.setTime();
        stage.groups[gr].items[i].check.wait = 500;
        stage.groups[gr].items[i].check._moved = true;
      } else {
        stage.groups[gr].items[i].isCorrect = true;
      }
    }
  }

  if (stage.correctBlock === true && droped !== false) {
    for (let gr in stage.groups) {
      let correct = true;
      for (let i in stage.groups[gr].items) {
        if (stage.groups[gr].items[i].block === true) continue;
        correct = !stage.groups[gr].items[i].isCorrect ? false : correct;
        if (stage.groups[gr].items[i].isCorrect) {
          if (stage.groups[gr].items[i].check.visible === true) {
            stage.groups[gr].items[i].block = true;

            if (
              typeof stage.groups[gr].items[i].good !== 'undefined' &&
              stage.groups[gr].items[i].good != null &&
              isCheckGood
            ) {
              stage.groups[gr].items[i].check._container.visible = false;
              stage.groups[gr].items[i].good._container.visible = true;
              if (stage.groups[gr].items[i]._container.cacheID !== 0)
                stage.groups[gr].items[i]._container.updateCache();
            }
          }
        }
      }

      for (let i in stage.groups[gr].items) {
        if (!correct) continue;
        stage.groups[gr].items[i].block = true;
      }
    }
  }

  if (isCorrect === true) {
    for (let gr in stage.groups) {
      for (let i in stage.groups[gr].items) {
        stage.groups[gr].items[i].block = true;
        if (stage.groups[gr].items[i].check.visible !== true || isCheckGood === false) {
          continue;
        }
        stage.groups[gr].items[i].check._container.visible = false;
        stage.groups[gr].items[i].good._container.visible = true;
        if (stage.groups[gr].items[i]._container.cacheID !== 0) stage.groups[gr].items[i]._container.updateCache();
      }
    }
  } else if (stage.removeAllFromBadTarget === true && droped !== false) {
    for (let j = 0; j < remove.length; j++) {
      let gr = remove[j];
      for (let i in stage.groups[gr].items) {
        stage.groups[gr].items[i].block = false;
        if (stage.groups[gr].items[i].check.visible !== true) {
          continue;
        }
        stage.groups[gr].items[i].check.toVisible = false;
        stage.groups[gr].items[i].check.setTime();
        stage.groups[gr].items[i].check.wait = 500;
        stage.groups[gr].items[i].check._moved = true;
        stage.groups[gr].items[i].good._container.visible = false;
        if (stage.groups[gr].items[i]._container.cacheID !== 0) stage.groups[gr].items[i]._container.updateCache();
      }
    }
  }

  return isCorrect;
};

cjsSelect.afterLoadSamples = function (stage) {
  stage.hideCards = [];
};

cjsSelect.resetGameAction = function (stage) {
  stage.hideCards.splice(0, stage.hideCards.length);
};

cjsSelect.tick = function (stage) {
  if (Array.isArray(stage.hideCards) && stage.hideCards.length > 0) {
    for (let i = 0; i < stage.hideCards.length; i++) {
      if (
        cjsEffects[stage.hideCards[i].effect].call(this, {
          check: stage.hideCards[i],
          stage: stage,
        }) === false
      ) {
        continue;
      }
      stage.hideCards[i].toVisible = -1;
      stage.hideCards.splice(i, 1);
    }
  }

  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      if (typeof stage.groups[gr].items[i].check == 'undefined' || stage.groups[gr].items[i].check == null) {
        continue;
      }
      if (
        stage.groups[gr].items[i].check.visible !== stage.groups[gr].items[i].check.toVisible &&
        stage.groups[gr].items[i].check._moved === true &&
        stage.groups[gr].items[i].block === false
      ) {
        cjsEffects[stage.groups[gr].items[i].check.effect].call(this, stage.groups[gr].items[i].check);
      }
    }
  }
};

class cjsCheck extends cjsHook {
  _effect;
  _speed;
  _wait;
  _waitStart;
  _autoHide;
  _idItem;
  _time;
  _toVisible;

  constructor(obj) {
    super(obj);
    this._idItem = obj[0].idItem;

    this._effect =
      typeof obj[2] === 'object' &&
      typeof obj[2].hide === 'object' &&
      typeof obj[2].hide.effect === 'string' &&
      typeof cjsEffects[obj[2].hide.effect.toLowerCase()] === 'function'
        ? obj[2].hide.effect.toLowerCase()
        : obj[1].defConfig.pair.hide.effect;

    this._speed =
      typeof obj[2] === 'object' && typeof obj[2].hide === 'object' && fJS.isNumeric(obj[2].hide.speed) === true
        ? obj[2].hide.speed
        : obj[1].defConfig.pair.hide.speed;

    this._waitStart =
      typeof obj[2] === 'object' && typeof obj[2].hide === 'object' && fJS.isNumeric(obj[2].hide.wait) === true
        ? obj[2].hide.wait
        : obj[1].defConfig.pair.hide.wait;

    this._autoHide =
      typeof obj[2] === 'object' && typeof obj[2].hide === 'object' && typeof obj[2].hide.removeCorrect === 'boolean'
        ? obj[2].hide.removeCorrect
        : obj[1].defConfig.pair.hide.removeCorrect;
  }

  setTime() {
    this._time = new Date();
  }

  get visible() {
    return this._container.visible;
  }
  set visible(v) {
    if (typeof this._effect !== 'string') this._container.visible = v;
    else {
      this._toVisible = v;
      this.setTime();
    }
  }

  get toVisible() {
    return this._toVisible;
  }
  set toVisible(v) {
    this._toVisible = v;
  }

  get idItem() {
    return this._idItem;
  }
  get effect() {
    return this._effect;
  }
  get speed() {
    return this._speed;
  }
  get wait() {
    return this._wait;
  }
  set wait(v) {
    this._wait = v;
  }
  get waitStart() {
    return this._waitStart;
  }
  get autoHide() {
    return this._autoHide;
  }
  get time() {
    return this._time;
  }
}
